export interface IExamFile {
  idFile: string;
  urlFile: string;
  fileType: string;
}

export class ExamFile {
  idFile: string;
  urlFile: string;
  fileType: string;

  constructor(data: IExamFile) {
    this.idFile = data.idFile;
    this.urlFile = data.urlFile;
    this.fileType = data.fileType;
  }
}
